import styled from 'styled-components'

interface StackProps {
  $direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  $gap?: number
  $align?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline'
  $justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
  $wrap?: 'nowrap' | 'wrap' | 'wrap-reverse'
  $padding?: string
}

export const StackAtom = styled.div<StackProps>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction || 'row'};
  gap: ${({ $gap }) => ($gap ? `${$gap}px` : '0px')};
  align-items: ${({ $align }) => $align || 'stretch'};
  justify-content: ${({ $justify }) => $justify || 'flex-start'};
  flex-wrap: ${({ $wrap }) => $wrap || 'nowrap'};
  padding: ${({ $padding }) => $padding};
`
